module.exports = __webpack_public_path__ + "img/event-no-company-image.50175331.svg";